// Load the main CSS file

import styles from "./scss/style.scss";

// Load jQuery & Bootstrap features

import $ from 'jquery';
import 'bootstrap/js/dist/scrollspy';
import 'bootstrap/js/dist/collapse';

// Register a basic scroll event handler

window.scrolled = false;

window.addEventListener("scroll", () => {
    window.scrolled = window.scrollY !== 0;
});

(function () {
    // Store intervals, to stop them, when focus is lost

    let intervals = [];

    // Add interval to check needed header background

    function setHeaderInterval() {
        const interval = window.setInterval(() => {
            const classnameScrolled = "bg-scrolled";
            const navbar = document.querySelector(".header > nav");

            if (window.scrolled === true && !navbar.classList.contains(classnameScrolled)) {
                navbar.classList.add(classnameScrolled);
            } else if (window.scrolled === false && navbar.classList.contains(classnameScrolled)) {
                navbar.classList.remove(classnameScrolled);
            }
        }, 250);

        intervals.push(interval);
    }

    setHeaderInterval();

    // Add smooth scrolling to a navigation link target

    const navbarHeight = document.querySelector('.header > .navbar').offsetHeight || 80;
    const mainNavigation = document.getElementById('main-navigation');

    mainNavigation.addEventListener('click', (e) => {
        const href = e.target.getAttribute('href');

        if (!href.includes('#')) {
            return;
        }

        const targetElementId = href.replace('#', '');
        const targetElement = document.getElementById(targetElementId);

        if (targetElement) {
            e.preventDefault();

            let targetOffset = targetElement.offsetTop + 30 - navbarHeight;

            if (targetOffset <= 0) {
                targetOffset = 0;
            }

            window.scrollTo({
                top: targetOffset,
                left: 0,
                behavior: 'smooth'
            });

            if (window.history) {
                window.history.pushState(
                    {},
                    e.target.textContent,
                    e.target.getAttribute('href')
                );
            }
        } else {
            window.location = `${window.baseUrl}#${targetElementId}`;
        }
    });

    // Add ScrollSpy to detect the active nagitation item on scrolling
    // data-spy="scroll" data-target="#main-navigation" data-offset="50"
    $('body').scrollspy({
        target: '#main-navigation',
        offset: navbarHeight
    });

    // Add custom fix for viewport height on mobile devices

    let resizingTimer = null;
    let resizingDelay = 250;
    let resizingWaiting = true;

    function handleResizeEvent() {
        if (resizingWaiting === true) {
            return null;
        }

        const currentTimestamp = new Date().getTime();

        if (resizingTimer === null) {
            return resizingTimer = currentTimestamp;
        }

        if (currentTimestamp - resizingTimer > 0) {
            resizingWaiting = true;
            resizingTimer = null;
        }
    }

    function resetVh() {
        const vh = window.innerHeight * 0.01;

        document.documentElement.style.setProperty('--vh', `${vh}px`);
        document.getElementById('first-view').style.height = 'calc(var(--vh, 1vh) * 100)';
    }

    function setVhInterval() {
        const firstViewElement = document.getElementById('first-view');

        if (firstViewElement && window.getComputedStyle) {
            const firstViewStyle = window.getComputedStyle(firstViewElement);
            const firstViewHeight = firstViewStyle.height;

            if (firstViewHeight.match(/px/i)) {
                const firstViewHeightInt = parseInt(firstViewHeight.replace('px', ''));

                if (window.innerWidth > 767 && firstViewHeightInt !== window.innerHeight) {
                    window.addEventListener('orientationchange', handleResizeEvent);
                    window.addEventListener('resize', handleResizeEvent);

                    const interval = window.setInterval(() => {
                        if (resizingWaiting) {
                            resetVh();
                            resizingWaiting = false;
                        }
                    }, resizingDelay);

                    intervals.push(interval);
                }
            }
        }
    }

    window.setTimeout(() => {
        setVhInterval();
    }, 250);

    function clearIntervals() {
        if (intervals.length !== 0) {
            for (let i = 0; i < intervals.length; i++) {
                window.clearInterval(intervals[i]);
                intervals.splice(i, 1);
            }
        }
    }

    window.addEventListener('beforeunload', () => {
        clearIntervals();
    });

    window.addEventListener('blur', () => {
        clearIntervals();
    });

    window.addEventListener('focus', () => {
        window.setTimeout(() => {
            setHeaderInterval();
            setVhInterval();
        }, 250);
    });

    // Register event handlers for visibility change of the tab / window

})(window, document);
